import PropTypes from 'prop-types';
import React, { Component } from 'react';
import isDomUsable from '@fenderdigital/utils/dom';

/**
 * ScrollContainer
 *
 * Like FlexContainer, but simply calls props.onTargetY once a props.targetY (window.scrollY)
 * Can be used to achieve things like position: sticky, which isn't supported in Tachyons
 */

class ScrollContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isTargetReached: false,
    };
    this.onScroll = this.onScroll.bind(this);
  }

  componentDidMount() {
    if (isDomUsable()) {
      window.addEventListener('scroll', this.onScroll);
    }
  }

  componentWillUnmount() {
    if (isDomUsable()) {
      window.removeEventListener('scroll', this.onScroll);
    }
  }

  onScroll() {
    const { targetY, onTargetY } = this.props;
    const currentY = window.scrollY;
    const isTargetReached = currentY >= targetY;
    if (isTargetReached !== this.state.isTargetReached) {
      this.setState({ isTargetReached });
      onTargetY(isTargetReached);
    }
  }

  render() {
    const { children, className } = this.props;
    return <div className={`scroll-container ${className}`}>{children}</div>;
  }
}

ScrollContainer.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  targetY: PropTypes.number,
  onTargetY: PropTypes.func,
};

ScrollContainer.defaultProps = {
  children: null,
  targetY: 235,
  className: '',
  onTargetY: () => {},
};

export default ScrollContainer;
